module.exports = "\n\n<app-footer></app-footer>"